import { FC, PropsWithChildren } from 'react';
import { Stack, Typography } from '@mui/material';
import { AutoAwesomeOutlined } from '@mui/icons-material';

const InfoItem: FC<PropsWithChildren> = ({ children }) => (
  <Stack direction="row" gap={1} alignItems="center">
    <AutoAwesomeOutlined fontSize="large" />
    <Typography>{children}</Typography>
  </Stack>
);

const ProfilePictureInfo: FC = () => (
  <Stack gap={1}>
    <InfoItem>Use a clear head shot (of just you).</InfoItem>
    <InfoItem>Choose a neutral background.</InfoItem>
    <InfoItem>Change your picture at any time.</InfoItem>
  </Stack>
);

export default ProfilePictureInfo;
